import { render, staticRenderFns } from "./RoomDelMember.vue?vue&type=template&id=32ca19fe&"
import script from "./RoomDelMember.vue?vue&type=script&lang=js&"
export * from "./RoomDelMember.vue?vue&type=script&lang=js&"
import style0 from "./RoomDelMember.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
  VFlex,
  VForm,
  VLayout,
  VSelect,
})
